<button mat-menu-item
	class="edit-activity-btn"
	data-cy="activity-options-edit-activity"
	(click)="editActivity()">
	<span translate="activity-list_activity-options-menu-edit-activity"></span>
</button>
<button mat-menu-item
	*ngIf="canDuplicateActivity()"
	class="duplicate-activity-btn"
	data-cy="activity-options-duplicate-activity"
	(click)="duplicateActivity()">
	<span translate="activity-list_activity-options-menu-duplicate-activity"></span>
</button>
<button mat-menu-item
	*ngIf="canAddToLibrary()"
	data-cy="copy-to-library"
	class="copy-to-library-btn"
	(click)="addToLibrary()">
	<span translate="activity-list_activity-options-menu-copy-to-library"></span>
</button>
<button mat-menu-item
	data-cy="activity-options-view-report-activity"
	class="view-assignment-report-btn"
	(click)="openActivityReport()">
	<span translate="activity-list_activity-options-menu-view-report"></span>
</button>
<button mat-menu-item
	*ngIf="shouldShowInstructorRubricReportButton()"
	class="view-instructor-rubric-report-btn"
	(click)="downloadActivityRubricReport('instructor')">
	<span translate="activity-list_activity-options-menu-instructor-rubric-report"></span>
</button>
<button mat-menu-item
	*ngIf="shouldShowStudentRubricReportButton()"
	class="view-student-rubric-report-btn"
	(click)="downloadActivityRubricReport('student')">
	<span translate="activity-list_activity-options-menu-student-rubric-report"></span>
</button>
<button mat-menu-item
	*ngIf="!limitActivityOption"
	data-cy="activity-options-delete-activity"
	class="archive-activity-btn"
	(click)="archiveActivity()">
	<span translate="activity-list_activity-options-menu-archive-activity"></span>
</button>
<mat-divider class="is-mobile" *ngIf="shouldShowFeedbackHold()"></mat-divider>
<span class="is-mobile feedback-hold" *ngIf="shouldShowFeedbackHold()" mat-menu-item>
	<feedback-hold></feedback-hold>
</span>
